export default __webpack_public_path__ + "static/newsroom_copy_3-78347efdfd93b5c109d15ebbb2c20e75.jpg";